import React, { useState, useEffect } from "react";
import { Area } from "@ant-design/plots";
import { getChannelOnlinePeopleNumStatistics } from "service/liveRecord";
import style from "./index.module.scss";
import moment from "moment";
interface CountOnlineProps {
    channelId: string;
    time: [string, string];
}
export default function CountOnline({ channelId, time }: CountOnlineProps) {
    const [data, setData2] = useState<Record<string, any>[]>([]);
    useEffect(() => {
        getChannelOnlinePeopleNumStatistics(channelId, time).then(res => {
            if (res.length > 0) {
                setData2(res);
            } else {
            }
        });
    }, [time]);
    const config = {
        data,
        xField: "currentDay",
        yField: "liveUV",
        xAxis: {
            range: [0, 1]
        },
        yAxis: {
            tickInterval: 1
        },
        isStack: true,
        areaStyle: () => {
            return {
                fill: "l(270) 0:#fff 0.3:#63E9FD 1:#57FDEA"
            };
        },
        slider: {
            start: 0,
            end: 1,
            trendCfg: {
                isArea: true
            }
        },
        smooth: true,
        tooltip: {
            customContent: (title: any, items: any) => {
                return (
                    <div className={style.customContent}>
                        <p className={style.customTitle}>
                            {moment(title).format("MMM Do")}
                        </p>
                        {items.map((el: any, index: any) => {
                            return (
                                <p className={style.customInfo} key={index}>
                                    在线{el.value}人
                                </p>
                            );
                        })}
                    </div>
                );
            }
        }
    };

    return (
        <div className={style.countOnline}>
            {data.length > 0 ? (
                <Area {...config} />
            ) : (
                <p className={style.empty}>无数据</p>
            )}
        </div>
    );
}
